import { render, staticRenderFns } from "./editEscort.vue?vue&type=template&id=2c5f9c21&scoped=true&"
import script from "./editEscort.vue?vue&type=script&lang=js&"
export * from "./editEscort.vue?vue&type=script&lang=js&"
import style0 from "./editEscort.vue?vue&type=style&index=0&id=2c5f9c21&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5f9c21",
  null
  
)

export default component.exports